import { render, staticRenderFns } from "./LandingWishlistFR.vue?vue&type=template&id=0ebeba05&scoped=true"
import script from "./LandingWishlistFR.vue?vue&type=script&lang=js"
export * from "./LandingWishlistFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebeba05",
  null
  
)

export default component.exports